import { Grade } from '../types';

type Band = Pick<Grade, 'name' | 'minPercentage' | 'color'> & { isActive?: boolean };

// Used only when a school has no grades configured. Same scheme as the backend.
const DEFAULT_GRADES: Band[] = [
  { name: 'A+', minPercentage: 80, color: '#2e7d32' },
  { name: 'A', minPercentage: 70, color: '#2196f3' },
  { name: 'B', minPercentage: 60, color: '#4c00b0' },
  { name: 'C', minPercentage: 50, color: '#fbc02d' },
  { name: 'F', minPercentage: 0, color: '#d32f2f' },
];

/**
 * The grade band a percentage falls in: the highest active band whose
 * minimum it reaches. Mirrors backend/src/utils/gradeUtils.ts, which grades
 * every stored score; the frontend uses this only to colour and label
 * numbers the server already computed.
 */
const gradeBandFor = (percentage: number, grades: Band[]): Band => {
  const active = (grades.length > 0 ? grades : DEFAULT_GRADES)
    .filter((g) => g.isActive !== false)
    .sort((a, b) => b.minPercentage - a.minPercentage);
  return active.find((g) => percentage >= g.minPercentage) ?? active[active.length - 1] ?? DEFAULT_GRADES[DEFAULT_GRADES.length - 1];
};

export const getGradeFromPercentage = (percentage: number, grades: Grade[]): string =>
  gradeBandFor(percentage, grades).name;

export const getGradeColorFromPercentage = (percentage: number, grades: Grade[]): string =>
  gradeBandFor(percentage, grades).color;
